<script>
import RawData from "@/components/widgets/raw-data.vue";

export default {
  name: "POSearchModal",
  components: {
    RawData
  },
  data() {
    return {
      tableData: null,
      loading: false,
      searchPoNumber: "",
      remainingResult: 0,
    };
  },
  created() {},
  methods: {
    resetData() {
      this.tableData = null;
      this.loading = false;
      this.searchPoNumber = "";
      this.remainingResult = 0;
    },
    getSearchPo(lastId) {
      if (this.searchPoNumber.trim() == "") {
        this.showToast("Search field is emplty.", "warning");
        return;
      }
      if (lastId == 0) {
        this.remainingResult = 0;
        this.tableData = [];
      }
      this.loading = true;
      this.$store
        .dispatch("po/FindPo", {
          body: this.searchPoNumber.trim(),
          lastId: lastId
        })
        .then((res) => {
          res.data.results.forEach((row) => {
            row.details = null;
            row.visible = false;
            row.loading = false;
          });
          this.tableData = this.tableData.concat(res.data.results);
          this.remainingResult = res.data.remainingResult;
          this.loading = false;
        })
        .catch(() => {
          this.showToast("Something went wrong - getting PO", "error");
          this.loading = false;
        });
    },
    getDetails(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.details = null;
        this.$store.dispatch("po/GetFindPoDetails", row.id).then((res) => {
          row.details = res.data;
        });
        setTimeout(() => {
          row.loading = false;
        }, 1000);
      }
    }
  }
};
</script>
<template>
  <b-modal
    id="po-search-modal"
    title="Purchase Order"
    size="xl"
    title-class="font-20"
    hide-footer
    no-close-on-backdrop
  >
    <div style="max-height: 800px; overflow: auto">
      <div class="col-5 mb-3">
        <form @submit.prevent="getSearchPo(0)">
          <b-form-input
            autocomplete="off"
            v-model="searchPoNumber"
            type="search"
            placeholder="Search PO Number..."
            class="form-control"
          ></b-form-input>
        </form>
      </div>
      <div
        class="border p-5 d-flex align-items-center justify-content-center"
        v-if="loading && remainingResult == 0"
      >
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
      <div
        class="border p-5 d-flex align-items-center justify-content-center"
        v-else-if="!tableData"
      >
        <span class="text-warning m-0"
          >Please input the PO number or PO keywords/details into search field
          and press Enter.</span
        >
      </div>
      <div
        class="border p-5 d-flex align-items-center justify-content-center"
        v-else-if="tableData && tableData.length == 0"
      >
        <h5 class="text-muted m-0">
          <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
        </h5>
      </div>
      <div v-else>
        <div
          class="text-muted"
          role="tablist"
          v-for="(po, index) in tableData"
          :key="po.id"
        >
          <b-card no-body class="shadow-none position-relative m-0">
            <div class="position-relative ms-1">
              <RawData
                :data="po"
                :keyId="po.id"
                v-if="$store.state.decrypt.isAdmin()"
              />
            </div>
            <b-card-header
              class="border cursor-pointer"
              @click="getDetails(po)"
              header-tag="header"
              role="tab"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <span>{{ po.poNumber }}</span>
                  <h5 class="mb-0">{{ po.description }}</h5>
                </div>
                <div>
                  <i
                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                    :class="{
                      'rotate-90': po.visible
                    }"
                  ></i>
                </div>
              </div>
            </b-card-header>
            <b-collapse
              class="border-bottom border-5"
              :visible="po.visible"
              :accordion="`poFinder-accordion-${po.id}`"
              role="tabpanel"
            >
              <b-card-body class="border">
                <div
                  class="p-3 d-flex align-items-center justify-content-center"
                  v-if="po.loading"
                >
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h6 class="mb-0">Loading...</h6>
                </div>
                <div v-else-if="po.details">
                  <div class="row">
                    <div class="col-md">
                      <div class="mb-2">
                        <div class="d-flex">
                          <b class="me-2" style="min-width: 100px"
                            >GIAMS Tab:</b
                          >
                          <span>{{
                            po.details.iars.length > 0
                              ? "Inspection"
                              : po.details.status == "POSTED"
                              ? po.details.expectedDelivery !=
                                "0001-01-01T00:00:00"
                                ? "Incoming Delivery"
                                : "Procurement (Unserve P.O)"
                              : "Procurement (Pending P.O)"
                          }}</span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="d-flex">
                          <b class="me-2" style="min-width: 100px">Cycle:</b>
                          <span>{{ po.details.cycle }}</span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="d-flex">
                          <b class="me-2" style="min-width: 100px">{{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }}:</b>
                          <span>{{ po.details.campus }}</span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="d-flex">
                          <b class="me-2" style="min-width: 100px"
                            >Delivery Unit:</b
                          >
                          <span>{{ po.details.deliveryUnit }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="po.details.iars.length > 0"
                      class="col-md-8 border-start border-3"
                    >
                      <div class="ms-2">
                        <div>
                          <table width="100%">
                            <thead>
                              <tr class="border-bottom">
                                <th class="pb-2">IAR Number</th>
                                <th
                                  class="pb-2 text-center"
                                  style="width: 150px"
                                >
                                  Cycle
                                </th>
                                <th
                                  class="pb-2 text-center"
                                  style="width: 150px"
                                >
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="iar in po.details.iars"
                                :key="iar.id"
                                class="border-bottom"
                              >
                                <td class="py-2 align-top">
                                  {{
                                    iar.iarNumber != "" ? iar.iarNumber : "N/A"
                                  }}
                                </td>
                                <td class="py-2 align-top text-center">
                                  {{ iar.cycle }}
                                </td>
                                <td
                                  class="py-2 align-top text-center"
                                  :class="{
                                    'text-warning': iar.status == 'PENDING',
                                    'text-purple': iar.status == 'POSTED',
                                    'text-success': iar.status == 'COMPLETED'
                                  }"
                                >
                                  {{ iar.status }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <div
            v-if="tableData.length == index + 1 && remainingResult > 0"
            class="d-flex justify-content-center mt-3"
          >
            <div
              class="d-flex align-items-center justify-content-center"
              v-if="loading"
            >
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
            <div v-else>
              <div class="text-warning mb-2 d-flex justify-content-center">
                {{ remainingResult }} POs remaining.
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-sm btn-primary mb-3"
                  @click="getSearchPo(po.id)"
                >
                  Load More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
